import { GetTypeEnum } from '@app/app.enum';
import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';

@Injectable()
export class TrackingService {
	private baseUrl = environment.apiGateway.apiUrl;
	private trackingApiUrl = 'Tracking/';

	/**
	 * Get Tracking
	 * @param appId
	 * @param cancelToken
	 */
	public async getTracking(
		key: GetTypeEnum,
		value: string,
		cancelToken?: CancelToken
	): Promise<models.IShipmentTracking> {
		try {
			const url = this.baseUrl + this.trackingApiUrl;
			const res = await axios.get<models.IShipmentTracking>(url, {
				cancelToken,
				params: {
					key,
					value,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/tracking.service.ts